import React, { useEffect } from 'react';
import { PageTransition } from '../components/shared/PageTransition';
import { SEOHelmet } from '../components/seo/SEOHelmet';
import styles from './RestrictedJurisdictions.module.css';

const RESTRICTED_JURISDICTIONS = [
  { name: 'Belarus', code: 'BLR' },
  { name: 'Burundi', code: 'BDI' },
  { name: 'Cuba', code: 'CUB' },
  { name: 'Equatorial Guinea', code: 'GNQ' },
  { name: 'Eritrea', code: 'ERI' },
  { name: 'Ethiopia', code: 'ETH' },
  { name: 'Iran', code: 'IRN' },
  { name: 'Korea, North', code: 'PRK' },
  { name: 'Lebanon', code: 'LBN' },
  { name: 'Libya', code: 'LBY' },
  { name: 'Myanmar', code: 'MMR' },
  { name: 'Palestine', code: 'PSE' },
  { name: 'Russia', code: 'RUS' },
  { name: 'Sri Lanka', code: 'LKA' },
  { name: 'Sudan', code: 'SDN' },
  { name: 'Syria', code: 'SYR' },
  { name: 'Tunisia', code: 'TUN' },
  { name: 'Ukraine', code: 'UKR' },
  { name: 'Virgin Islands (US)', code: 'VIR' },
  { name: 'South Sudan', code: 'SSD' },
];

export const RestrictedJurisdictions: React.FC = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <PageTransition>
      <SEOHelmet
        title="Restricted Jurisdictions"
        description="List of restricted jurisdictions where GCBusiness services are not available due to regulatory and compliance requirements."
        canonical="https://gcbusiness.space/restricted-jurisdictions"
      />
      <div className={styles.restrictedPage}>
        <div className={styles.container}>
          <h1 className={styles.title}>Restricted Jurisdictions</h1>

          <section className={styles.section}>
            <p className={styles.intro}>
              Due to regulatory and compliance requirements, GCBusiness services are not available to residents or entities registered in the following jurisdictions:
            </p>
          </section>

          <section className={styles.section}>
            <div className={styles.jurisdictionsList}>
              {RESTRICTED_JURISDICTIONS.map((jurisdiction, index) => (
                <div key={jurisdiction.code} className={styles.jurisdictionItem}>
                  <span className={styles.jurisdictionName}>{jurisdiction.name}</span>
                  <span className={styles.jurisdictionCode}>({jurisdiction.code})</span>
                </div>
              ))}
            </div>
          </section>

          <section className={styles.section}>
            <p className={styles.note}>
              If you have any questions regarding restricted jurisdictions or need clarification about your eligibility, please contact us at{' '}
              <a href="mailto:info@gcbusiness.space" className={styles.link}>info@gcbusiness.space</a>.
            </p>
          </section>
        </div>
      </div>
    </PageTransition>
  );
};

